import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../../api/v1";
import { ApiResponse } from "../../../../../../../types/api-response";
import axios from "../../../../../../../utils/axiosInceptor";

type Payload = {
  leaseId: string;
  vacatingDate: string;
  notifyUsers: string;
};

const earlyTerminateLease = async (data: Payload) => {
  const url = `${apiV1Endpoint}/booking/leaseEarlyTermination`;
  const response = await axios.post<ApiResponse>(url, data);
  return response.data.result;
};

type UseEarlyTerminateLeaseOptions = {
  onSuccess?: () => void;
};

export const useEarlyTerminateLease = (options: UseEarlyTerminateLeaseOptions = {}) => {
  const { onSuccess } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: earlyTerminateLease,
    onSuccess,
  });

  return {
    earlyTerminateLease: mutateAsync,
    isPendingEarlyTerminateLease: isPending,
  };
};
